export default __webpack_public_path__ + "static/media/Stone.0950a99c.jpg";